<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar title="Cambio" :has-back-button="true" />
      <o-message-header
        icon="lock-success"
        text="Je wagen is goed op slot"
        :success="true"
      />
      <o-section>
        <p>
          Je hoeft geen verdere stappen te ondernemen. Op het einde van de maand
          krijg je een overzicht van de kostprijs van je ritten.
        </p>
        <p class="u-small u-muted">
          Hulp nodig bij het sluiten van je wagen? Neem contact op met
          <a href="#">de Cambio-helpdesk</a>.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Klaar" to="/sales/car/cambio" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioEdit',
  components: {
    OMessageHeader,
    OPayButton
  }
}
</script>
